
// let debounce = require('debounce')
import debounce from 'debounce';

// utils & vendors
import { Scroll } from './utils/scroll'

// components
import { Hero } from "./partials/hero"
import { Sound } from "./partials/sound"
import { Form } from "./partials/form"
import { Slider } from './partials/slider'
import { Menu } from './partials/menu'
import { SlideUpFadeIn } from './utils/slide-up-fade-in'
import {ImageFadeInParallax} from './utils/image-fade-in-parallax'
import {FadeIn} from './utils/fade-in'
import ClickTrack from './utils/click-track'
import { BlockProducts } from "./partials/blockProducts";
import { joannaCta } from "./partials/joanna-cta";
/*import { headerScroller } from "./partials/headerScroll";*/


// all elements that need to implement a resize action
let homepageDynamicElements = window._HCEhomepageDynamicElements  = []



let getWindowHeightWidth = () => {
    return {
        w: window.innerWidth,
        h: window.innerHeight,
    }
}
let currentWindowSize = getWindowHeightWidth()
const resizeEvent = function () {
    console.log('resize')
    let newWindowSize = getWindowHeightWidth()
    let changedHeight = false, changedWidth = false
    if (currentWindowSize.w !== newWindowSize.w) {
        changedWidth = true
    }
    if (currentWindowSize.h !== newWindowSize.h) {
        changedHeight = true
    }

    homepageDynamicElements.forEach(el => {
        // console.log('resize', el)
        if (el.onResize && typeof(el.onResize) === "function") {
            el.onResize(changedWidth, changedHeight)
        }
    })
}
function support_format_webp()
{
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d')))
    {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    else
    {
        // very old browser like IE 8, canvas not supported
        return false;
    }
}
const loadedEvent = function(event) {
    console.log('loaded');
    new Scroll();
    new Menu();


    if(support_format_webp()) {
        document.body.classList.add('webp');
    }
    for (let el of document.querySelectorAll(`.header`)) {
        console.log('Loading hero')
        homepageDynamicElements.push(new Hero(el))
    }
    for (let el of document.querySelectorAll(`.sound_cta`)) {
        console.log('Loading sound')
        let isSoundTrigger = (el.dataset && el.dataset.isTrigger !== undefined)
        // console.log(el, isSoundTrigger)
        homepageDynamicElements.push(new Sound(el, isSoundTrigger))
    }
    document.querySelectorAll(`.form-data-lead__form form`).forEach((form) => {
        console.log('Loading form')
        new Form(form, ['name', 'surname', 'email', 'country', 'city', 'role', 'privacy_marketing'])
    })
    document.querySelectorAll(`.slider .splide`).forEach((slide) => {
        console.log('Loading slide')
        new Slider(slide);
    })

    document.querySelectorAll('[data-animation]').forEach((el) => {

        switch (el.dataset.animation) {
            case 'slide-up-fade-in':
                new SlideUpFadeIn(
                    el,
                    el.dataset.animationShift ? el.dataset.animationShift : 100,
                    el.dataset.animationDuration ? el.dataset.animationDuration : 2,
                    el.dataset.animationThreshold ? el.dataset.animationThreshold : 0.7,
                    el.dataset.animationDelay ? el.dataset.animationDelay : 0
                )
                break;
            case 'image-fade-in-parallax':
                new ImageFadeInParallax(el)
                break;
            case 'fade-in':
                new FadeIn(el)
                break;
        }
    })

    document.querySelectorAll('[data-tracking]').forEach((el) => {
        // console.log('Loading tracking')
        new ClickTrack(el)
    })

    document.querySelectorAll('.block__products').forEach(() => {
        console.log('Loading block products')
        new BlockProducts();
    })
    document.querySelectorAll('.joanna-block').forEach(() => {
        console.log('managing joanna cta')
        new joannaCta();
    })

    //new headerScroller();
}
loadedEvent()
window.addEventListener('resize', debounce(resizeEvent, 250))



